import type { DeleteWizardMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

type DeleteWizardTRPCInput = {
  RiskId: string;
};

/**
 * Maps TRPC mutation response to match the GraphQL mutation structure
 */
const mapTrpcResponseToGraphQL = (trpcData: {
  affectedRows: number;
}): DeleteWizardMutation => {
  return {
    deleteWizardById: {
      __typename: 'GenericMutationOutput',
      affected_rows: trpcData.affectedRows,
    },
  };
};

export const useDeleteWizardTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.wizard.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.wizard.wizards.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.wizard.wizardById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteWizard: async (
      input: DeleteWizardTRPCInput
    ): Promise<DeleteWizardMutation> => {
      const result = await mutation.mutateAsync(input);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
